/** Match sidebar path to current route (exact for hubs like `/` and `/journals`). */
export function matchNavPath(to: string | undefined, path: string, exact?: boolean): boolean {
  if (!to) return false;
  const clean = to.replace(/\/+$/, '') || '/';
  const cur = path.replace(/\/+$/, '') || '/';
  if (clean === '/' || exact) return cur === clean;
  return cur === clean || cur.startsWith(`${clean}/`);
}

export function anyChildActive(
  children: Array<{ to?: string; exact?: boolean; children?: any[] }> | undefined,
  path: string
): boolean {
  if (!children?.length) return false;
  for (const c of children) {
    if (c.to && matchNavPath(c.to, path, c.exact)) return true;
    if (c.children && anyChildActive(c.children, path)) return true;
  }
  return false;
}
